// "Sign out everywhere" on a person (people.signOutEverywhere): every browser and iPad of theirs in
// this company ends now, asked twice. The owner's help for someone locked out is this, then "sign
// in with an emailed code": they can set a new password there for ten minutes.
import { useState } from 'react';
import { RpcError } from '@flowology/client';
import { client } from '../api.ts';

export function SignOutEverywhere({
  staffId,
  name,
  onDone,
}: {
  staffId: string;
  name: string;
  /** The words for the toast, and the list re-read. */
  onDone: (toast: string) => void;
}) {
  const [asking, setAsking] = useState(false);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await client.call<{ ended: number }>('people.signOutEverywhere', { staffId });
      onDone(
        r.ended
          ? `${name} is signed out everywhere here. They sign in again as usual, or with an emailed code.`
          : `${name} wasn’t signed in anywhere here.`,
      );
    } catch (e) {
      onDone(e instanceof RpcError ? e.message : 'That didn’t work. Try again.');
    } finally {
      setBusy(false);
      setAsking(false);
    }
  };
  if (!asking)
    return (
      <button className="btn soft" aria-label={`Sign ${name} out everywhere`} onClick={() => setAsking(true)}>
        Sign out everywhere…
      </button>
    );
  return (
    <span className="confirm-inline" role="group" aria-label={`Sign ${name} out everywhere?`}>
      <span className="small">Sign {name} out of every browser and iPad here?</span>
      <button className="btn danger small" disabled={busy} onClick={() => void go()}>
        {busy ? 'Signing out…' : 'Sign out'}
      </button>
      <button className="btn quiet small" disabled={busy} onClick={() => setAsking(false)}>
        Cancel
      </button>
    </span>
  );
}
